// Centralized currency/locale formatters

export type Jurisdiction = 'canada' | 'usa';

const localeMap: Record<Jurisdiction, string> = {
  canada: 'en-CA',
  usa: 'en-US',
};

const currencyMap: Record<Jurisdiction, string> = {
  canada: 'CAD',
  usa: 'USD',
};

export function createFormatter(jurisdiction: Jurisdiction) {
  const locale = localeMap[jurisdiction];
  const currency = currencyMap[jurisdiction];

  const fmt = (n: number): string =>
    new Intl.NumberFormat(locale, { style: 'currency', currency }).format(n);

  const fmtCompact = (n: number): string =>
    new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 0 }).format(n);

  const currencySymbol = jurisdiction === 'usa' ? 'US$' : '$';

  return { fmt, fmtCompact, locale, currency, currencySymbol };
}

// Default formatter for backward compat
export const defaultFormatter = createFormatter('canada');
